import gql from 'graphql-tag';

export const CREATE_PAYMENT_SETTING = gql`
  mutation createPaymentsSettings(
    $payPalSettings: [PayPalInput]
    $stripeSettings: [StripeInput]
    $payOnArrival: Boolean
    $businessOwnerId: Int
  ) {
    createPaymentsSettings(
      payPalSettings: $payPalSettings
      stripeSettings: $stripeSettings
      payOnArrival: $payOnArrival
      businessOwnerId: $businessOwnerId
    ) {
      ok
    }
  }
`;

export const UPDATE_PAYMENT_SETTING = gql`
  mutation updatePaymentsSettings(
    $payPalSettings: [PayPalInput]
    $stripeSettings: [StripeInput]
    $deletedPayPalSettingsId: [Int]
    $deletedStripeSettingsId: [Int]
    $deletedPayOnArrivalSettingsId: [Int]
    $payOnArrival: Boolean
    $businessOwnerId: Int
  ) {
    updatePaymentsSettings(
      payPalSettings: $payPalSettings
      stripeSettings: $stripeSettings
      payOnArrival: $payOnArrival
      businessOwnerId: $businessOwnerId
      deletedPayPalSettingsId: $deletedPayPalSettingsId
      deletedStripeSettingsId: $deletedStripeSettingsId
      deletedPayOnArrivalSettingsId: $deletedPayOnArrivalSettingsId
    ) {
      ok
    }
  }
`;

export const CREATE_INTEGRATIONS_SETTINGS = gql`
  mutation createIntegrationsSettings(
    $trekksoftSettings: TrekkSoftSettingsInput
    $expediaSettings: ExpediaSettingsInput
    $bookingSettings: BookingSettings
    $businessOwnerId: Int
  ) {
    createIntegrationsSettings(
      trekksoftSettings: $trekksoftSettings
      expediaSettings: $expediaSettings
      bookingSettings: $bookingSettings
      businessOwnerId: $businessOwnerId
    ) {
      ok
    }
  }
`;

export const UPDATE_INTEGRATIONS_SETTINGS = gql`
  mutation updateIntegrationsSettings(
    $trekksoftSettings: TrekkSoftSettingsInput
    $expediaSettings: ExpediaSettingsInput
    $bookingSettings: BookingSettings
    $deletedTrekksoftSettingsId: Int
    $deletedExpediaSettingsId: Int
    $deletedBookingSettingsId: Int
    $deletedTrekksoftCategories: [Int]
    $businessOwnerId: Int
  ) {
    updateIntegrationsSettings(
      businessOwnerId: $businessOwnerId
      trekksoftSettings: $trekksoftSettings
      expediaSettings: $expediaSettings
      bookingSettings: $bookingSettings
      deletedExpediaSettingsId: $deletedExpediaSettingsId
      deletedBookingSettingsId: $deletedBookingSettingsId
      deletedTrekksoftSettingsId: $deletedTrekksoftSettingsId
      deletedTrekksoftCategories: $deletedTrekksoftCategories
    ) {
      ok
    }
  }
`;

export const CREATE_GOOGLE_ANALYTICS_SETTINGS = gql`
  mutation createGoogleAnalyticsSettings(
    $googleAnalyticsId: String!
    $businessOwnerId: Int
  ) {
    createGoogleAnalyticsSettings(
      googleAnalyticsId: $googleAnalyticsId
      businessOwnerId: $businessOwnerId
    ) {
      id
    }
  }
`;

export const UPDATE_GOOGLE_ANALYTICS_SETTINGS = gql`
  mutation updateGoogleAnalyticsSettings(
    $googleAnalyticsId: String!
    $businessOwnerId: Int
    $googleAnalyticsSettingsId: Int
  ) {
    updateGoogleAnalyticsSettings(
      googleAnalyticsId: $googleAnalyticsId
      businessOwnerId: $businessOwnerId
      googleAnalyticsSettingsId: $googleAnalyticsSettingsId
    ) {
      ok
    }
  }
`;

export const SET_EMAIL_TEMPLATE = gql`
  mutation setEmailTemplate($subject: String!, $body: String!, $ownerId: Int) {
    setEmailTemplate(subject: $subject, body: $body, ownerId: $ownerId) {
      status
    }
  }
`;
